import { render, staticRenderFns } from "./EmailInvites.vue?vue&type=template&id=1091d7d0&"
import script from "./EmailInvites.vue?vue&type=script&lang=js&"
export * from "./EmailInvites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports